"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3.752a8.248 8.248 0 1 0 0 16.497 8.248 8.248 0 0 0 0-16.497M9.589 13.888a.483.483 0 0 1-.684 0l-1.546-1.546a.483.483 0 0 1 0-.684l1.546-1.545a.483.483 0 1 1 .684.684L8.385 12l1.204 1.204a.483.483 0 0 1 0 .684m4.432-5.494-3.148 7.582a.484.484 0 0 1-.894-.371l3.148-7.582a.484.484 0 0 1 .894.371m2.62 3.948-1.545 1.546a.483.483 0 1 1-.684-.684L15.615 12l-1.203-1.203a.483.483 0 1 1 .684-.684l1.545 1.545a.483.483 0 0 1 0 .684"
}), 'BlogEmbedFilled');
//# sourceMappingURL=index.js.map